import { Box, styled } from "@mui/material";

export const Flex = styled(Box)(() => ({
     display: "flex",
     justifyContent: "center",
     alignItems: "center",
}));
